import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import SessionService from 'services/SessionService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
    sessionData: [],
    singleSession:[],
    sessionPlayer: [],
}


export const getSession = createAsyncThunk('session/getSession', async (params, { rejectWithValue }) => {
	
	try {
		const response = await SessionService.getSession(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});


export const getSessionWithId = createAsyncThunk('session/getSessionWithId', async (params, { rejectWithValue }) => {
	
	try {
		const response = await SessionService.getSessionWithId(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const getSessionPlayer = createAsyncThunk('session/getSessionPlayer', async (params, { rejectWithValue }) => {
	
	try {
		const response = await SessionService.getSessionPlayer(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});


export const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getSession.pending, (state) => {
            state.loading = true
        })
        .addCase(getSession.fulfilled, (state, action) => {
            state.loading = false
            state.sessionData = action.payload
        })
        .addCase(getSession.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
       
        .addCase(getSessionWithId.pending, (state) => {
            state.loading = true
        })
        .addCase(getSessionWithId.fulfilled, (state, action) => {
            state.loading = false
            state.singleSession = action.payload
        })
        .addCase(getSessionWithId.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getSessionPlayer.pending, (state) => {
            state.loading = true
        })
        .addCase(getSessionPlayer.fulfilled, (state, action) => {
            state.loading = false
            state.sessionPlayer = action.payload
        })
        .addCase(getSessionPlayer.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
       
    }
});


export default sessionSlice.reducer;